import { useId } from '@react-aria/utils';
import { useEffect } from 'react';
import { onCloseMap } from './use-close-on-scroll.esm.js';

/*
 *  Ported code from react-aria-components as of V.1.2.1 use the original commit in the repo
 *  to diff any added code since the original commit.
 */


/**
 * Handles the behavior and accessibility for an overlay trigger, e.g. a button
 * that opens a popover, menu, or other overlay that is positioned relative to the trigger.
 */
function useOverlayTrigger(props, state, ref) {
  var type = props.type;
  var isOpen = state.isOpen;

  // Backward compatibility. Share state close function with useOverlayPosition so it can close on scroll
  // without forcing users to pass onClose.
  useEffect(function () {
    if (ref && ref.current) {
      onCloseMap.set(ref.current, state.close);
    }
  });

  // Aria 1.1 supports multiple values for aria-haspopup other than just menus.
  // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
  // However, we only add it for menus for now because screen readers often
  // announce it as a menu even for other values.
  var ariaHasPopup = undefined;
  if (type === 'menu') {
    ariaHasPopup = true;
  } else if (type === 'listbox') {
    ariaHasPopup = 'listbox';
  }
  var overlayId = useId();
  return {
    triggerProps: {
      //@ts-expect-error
      'aria-haspopup': ariaHasPopup,
      'aria-expanded': isOpen,
      //@ts-expect-error
      'aria-controls': isOpen ? overlayId : null,
      onPress: state.toggle
    },
    overlayProps: {
      id: overlayId
    }
  };
}

export { useOverlayTrigger as default };
//# sourceMappingURL=use-overlay-trigger.esm.js.map
